import React from 'react';
import { RotateCcw } from 'lucide-react';

export const RefreshButton = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <button
      onClick={handleRefresh}
      className="flex items-center space-x-2 px-4 py-2 rounded-md text-gray-800 font-medium"
    >
      <RotateCcw className="w-5 h-5" />
    </button>
  );
};
